import LineManagers from './cell-line-managers'
import Actions from './cell-actions'

const Cell = {
  LineManagers,
  Actions,
}

export default Cell
